// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"9016fcc8","242":"4210f6e1","307":"a0edea52","406":"4178b7d3","468":"306abf40","787":"2b3c8e21"}[chunkId] + ".chunk.js";
};